import { useEffect } from 'react';

import { KingdomAndPlanResponse } from '../@types/KingdomResponse';
import { KdKanban } from '../@types/State';
import { useIntelState } from '../context/IntelState';
import RestUtilities from '../services/RestUtilities';

export const setEnemyData = async (
  server: number,
  enemyKd: string,
  dispatch: React.Dispatch<any>
) => {
  dispatch({ type: 'SET_LOADING', payload: true });
  const response = await RestUtilities.get(
    `Kingdom/v1/EnemyKingdom?server=${server}&location=${enemyKd}`
  );
  if (response.ok) {
    const responseContent: KingdomAndPlanResponse = response.content;
    const plan: KdKanban | undefined =
      responseContent.warPlan && JSON.parse(responseContent.warPlan);
    responseContent.kingdom &&
      dispatch({ type: 'SET_ENEMY_DATA', payload: responseContent.kingdom });
    plan && dispatch({ type: 'SET_ENEMY_PLAN', payload: plan });
  } else {
    dispatch({ type: 'SET_ENEMY_DATA', payload: undefined });
    dispatch({ type: 'SET_ENEMY_PLAN', payload: undefined });
  }
  dispatch({ type: 'SET_LOADING', payload: false });
};

export const setEnemyPlan = async (
  server: number,
  location: string | undefined,
  dispatch: React.Dispatch<any>
) => {
  const response = await RestUtilities.get(
    `WarPlan/v1/Get?server=${server}&location=${location}`
  );
  if (response.ok) {
    const kdResponse: any = response.content;
    const newState: KdKanban = JSON.parse(kdResponse.json);
    dispatch({ type: 'SET_ENEMY_PLAN', payload: newState });
  } else {
    dispatch({ type: 'SET_ENEMY_PLAN', payload: undefined });
  }
};

export const useEnemyData = () => {
  const { intelState, intelDispatch } = useIntelState();
  useEffect(() => {
    if (
      intelState.enemyData?.server !== intelState.server ||
      intelState.enemyData.location !== intelState.enemyKd
    ) {
      setEnemyData(intelState.server, intelState.enemyKd, intelDispatch);
    }
  }, [
    intelDispatch,
    intelState.enemyData,
    intelState.enemyKd,
    intelState.server,
  ]);
};
